import script from "./PageBackground.vue?vue&type=script&setup=true&lang=js"
export * from "./PageBackground.vue?vue&type=script&setup=true&lang=js"

import "./PageBackground.vue?vue&type=style&index=0&id=4336fdd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4336fdd6"]])

export default __exports__